import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PATHS } from '@/routes/paths';
export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="404"
      subTitle={t('app.notFound')}
      extra={
        <Button type="primary" onClick={() => navigate(PATHS.bind, { replace: true })}>
          {t('common.back')}
        </Button>
      }
    />
  );
}
